import { PropsWithChildren } from 'react';
import { Listbox, ListboxItem } from '@heroui/listbox';

import PopoverContainer from '@/components/PopoverContainer/PopoverContainer.tsx';

interface SelectListProps {
  label: string;
  selected: string;
  options: { value: string; key: string; }[];
  onChange: (key: string) => void;
}

function SelectList({ label, options, selected, onChange, children }: PropsWithChildren<SelectListProps>) {
  return (
    <PopoverContainer
      content={(
        <Listbox
          aria-label={label}
          className="min-w-24"
          color="primary"
          selectedKeys={[selected]}
          selectionMode="single"
          onSelectionChange={([newKey]) => onChange(newKey.toString())}
        >
          {options.map(({ key, value }) => (
            <ListboxItem key={key}>{value}</ListboxItem>
          ))}
        </Listbox>
      )}
      trigger={children}
    />
  );
}

export default SelectList;
